





























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { IRequisition, RequisitionStatus } from '@/models/requisition';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import RequisitionStatusDisplay from '../requisition-common/RequisitionStatusDisplay.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, RequisitionStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    requisitionActivities: get<Transition[]>(
      'requisition/getRequisitionActivities'
    ),

    RequisitionStatus: () => RequisitionStatus
  },

  methods: {
    moment,

    ...mapActions({
      fetchRequisitionActivities: 'requisition/fetchRequisitionActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(requisition: IRequisition) {
      this.clearAllErrors();

      this.dialog = true;
      this.loading = true;

      this.fetchRequisitionActivities(requisition.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
